<template>
  <div class="footer">
    <div class="footer-content">
      <div class="first-part">
        <div class="logo-box">
          <img class="logo" src="@/assets/img/footer_logo.jpg" alt="logo">
          <img class="inno" src="@/assets/img/footer_inno.jpg" alt="1">
          <img class="marx" src="@/assets/img/footer_marx.jpg" alt="2">
        </div>
        <div class="support">
          <a href="">关于我们</a>
          <a href="">联系我们</a>
          <a href="">常见问题</a>
          <a href="">免责声明</a>
          <a href="">友情链接</a>
          <a href="" style="border:none;padding:0">服务商登录</a>
        </div>
      </div>
      <div class="second-part">
        <h4>战略合作伙伴</h4>
        <p><span>海淀置业</span><span>海淀区政府</span><span>中关村海淀园</span><span>中关村管委会</span></p>
        <p><span>中关村互联网教育创新中心</span><span>和义广业</span></p>
      </div>
      <div class="third-part">
        <div>
          <img src="@/assets/img/innoway.jpeg" alt="二维码">
          <p>创业大街公众号</p>
        </div>
        <div>
          <img src="@/assets/img/innohall.jpg" alt="二维码">
          <p>创业会客厅公众号</p>
        </div>
      </div>
    </div>
    <div class="ICP">版权所有：北京中关村创业大街科技服务有限公司 京ICP备14017783号-2</div>
  </div>
</template>

<script>
export default {
  name:"Footer"
}
</script>

<style lang="scss" scoped>
.footer{
  height: 173px;
  background: #2f3337;
  color: #EEEEEE;
  .footer-content {
    display: flex;
    width: 1154px;
    height: 150px;
    margin: 0 auto;
    .first-part {
      flex: 1;
      .logo-box {
        display: flex;
        justify-content: space-between;
        height: 40px;
        margin-top: 20px;
        .logo {
          width: 140px;
          height: 30px;
        }
        .inno {
          width: 80px;
          height: 25px;
        }
        .marx {
          width: 100px;
          height: 30px;
        }
      }
      .support {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        a {
          height: 12px;
          line-height: 12px;
          text-decoration: none;
          color: #fff;
          font-size: 12px;
          border-right: 1px solid #fff;
          padding-right: 7px;
        }
      }
    }
    .second-part {
      flex: 1;
      padding-left: 40px;
      h4 {
        font-weight: 600;
        margin: 20px 0 30px 0;
      }
      p {
        font-size: 12px;
        margin-top: 15px;
        span {
          margin-right: 15px;
        }
      }
    }
    .third-part {
      flex: 1;
      display: flex;
      div {
        width: 100px;
        margin: 20px 0 10px 20px;
        img {
          width: 100%;
        }
        p {
          font-size: 12px;
          text-align: center;
          color: #ccc;
        }
      }
    }
  }
  .ICP {
    height: 23px;
    line-height: 23px;
    background: #323a42;
    text-align: center;
    color: #666;
    font-size: 12px;
  }
}
</style>>

 